import i18next from 'i18next';
import * as Yup from 'yup';

export const validationSchema = Yup.object().shape({
  newPassword: Yup.string()
    .required(i18next.t('password.required') as string)
    .min(6, i18next.t('password.tooShort') as string),
  confirmNewPassword: Yup.string().oneOf([Yup.ref('newPassword'), undefined], 'Passwords must match'),
});
